import React from "react";
import { Star } from "lucide-react";
import { reviews } from "../mock/mock";

export default function Reviews() {
  return (
    <section id="reviews" className="border-b border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12">
          <div className="max-w-2xl">
            <div className="section-label mb-4">Customer Satisfaction</div>
            <h2 className="section-heading text-[30px] sm:text-[36px] md:text-[46px] leading-[1.05]">
              Client Reviews &amp; Feedback
            </h2>
            <p className="mt-5 text-[15px] leading-relaxed text-[#b6b3ab] max-w-xl">
              Real customer reviews from homeowners and contractors throughout
              Twin Falls, Jerome, and the Magic Valley.
            </p>
          </div>

          <div className="card-outline rounded-xl px-5 py-4 flex items-center gap-4">
            <div>
              <div className="font-display font-extrabold text-[28px] text-[#f4efe6] leading-none">
                5.0
              </div>
              <div className="text-[10.5px] tracking-[0.22em] text-[#8a877f] uppercase mt-1">
                Rating
              </div>
            </div>
            <div className="h-10 w-px bg-white/10" />
            <div>
              <div className="flex items-center gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star
                    key={i}
                    size={14}
                    className="fill-[#c9b98a] text-[#c9b98a]"
                  />
                ))}
              </div>
              <div className="text-[12px] text-[#c8c5bc] mt-1">
                100% Recommended in Magic Valley
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {reviews.map((r) => (
            <article
              key={r.id}
              className="card-outline rounded-xl p-7 hover-lift"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: r.rating }).map((_, i) => (
                    <Star
                      key={i}
                      size={15}
                      className="fill-[#c9b98a] text-[#c9b98a]"
                    />
                  ))}
                </div>
                <span className="text-[11.5px] text-[#8a877f]">{r.date}</span>
              </div>
              <p className="text-[14px] text-[#c8c5bc] leading-relaxed">
                &ldquo;{r.text}&rdquo;
              </p>
              <div className="mt-6 pt-5 border-t divider-soft flex items-center gap-3">
                <div className="h-11 w-11 rounded-full bg-[#1a1a1c] border border-white/10 flex items-center justify-center font-display font-bold text-[15px] text-[#c9b98a]">
                  {r.initial}
                </div>
                <div>
                  <div className="font-display font-bold text-[14px] text-[#f4efe6]">
                    {r.name}
                  </div>
                  <div className="text-[11.5px] text-[#8a877f]">
                    {r.location} • {r.project}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
